import moment from "moment-timezone";

/**
 * check timeline
 * @param {string} startDateTime
 * @param {string} endDateTime
 * @returns 0: upcoming, 1: going, 2: passed
 */
export const checkTimeline = (startDateTime, endDateTime) => {
    const isComing = moment(new Date().toISOString()).isBefore(moment(startDateTime));
    // in case upcoming
    if (isComing) {
        return 0;
    }
    // in case is going
    const isGoing = moment(new Date().toISOString()).isBefore(moment(endDateTime));
    if (isGoing) {
        return 1;
    }
    // is case passed
    return 2;
};

/**
 * format numer
 * @param {any} number
 * @returns
 */
export const formatNumber = (number) => {
    if (number > 1) return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return number;
};
